function factory({ window, document, thn }) {

  const engine = {};

  engine.languageCheck = function languageCheck(ctx) {
    return new Promise(function (resolve) {
      const aux = window.location.pathname.match(ctx.urlRe);
      if (aux && ctx.langs.test(aux[1])) {
        resolve(aux[1]);
      }
    });
  };

  engine.onStateChange = function onStateChange(ctx) {
    thn.languageCheck().then(function ({ changed }) {
      if (!changed) {
        thn.pageCheck();
      }
    });
  };

  return engine;

}

export { factory };
